import React, { useState } from "react";
import { sidebarData } from "./sidebarData/sidebarData.js";
import { useLocation, useNavigate } from "react-router-dom";
import Logout from "../../../assets/Logout.jsx";
import ConfirmationModal from "../../modals/ConfirmationModal.jsx";
import toast from "react-hot-toast";
import { LogoutApi } from "../../../api/request/auth.js";
import { useDispatch, useSelector } from "react-redux";
import { setloggedIn } from "../../../store/Slices/userSlice.js";
import { clearCookies } from "../../../services/Cookies.jsx";
import siteConfig from "../../../config.js";

const Sidebar = ({ setIsDrawerOpen }) => {
  const isBookKeeper = useSelector((state) => state.user.is_bookkeeper);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const getFirstPath = (path) => {
    const parts = path.split("/");
    return parts.length > 1 ? "/" + parts[1] : path;
  };

  const isActivePath = (path) => {
    let active = false;
    path?.map((item) => {
      if (item == getFirstPath(pathname)) {
        active = true;
      }
    });
    return active;
  };

  const clearAll = () => {
    localStorage.clear();
    dispatch(setloggedIn(false));
    clearCookies();
    navigate("/login");
  };

  const logoutHandler = async () => {
    try {
      setIsLoading(true);
      const { data } = await LogoutApi();
      if (data?.status) toast.success(data?.message);
      clearAll();
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
      clearAll();
    } finally {
      setIsLoading(false);
    }
  };

  const handleClick = (url) => {
    if (!url) return;
    navigate(url);
    if (setIsDrawerOpen) setIsDrawerOpen(false);
  };

  return (
    <div className="w-[250px] fixed border-r">
      <div className="border-b px-4 py-1">
        {siteConfig?.logo ? (
          <img
            src={siteConfig?.logo}
            alt="logo"
            className="h-16 w-full object-contain"
          />
        ) : (
          <h2 className="font-bold text-3xl text-center my-[14px] uppercase">
            {siteConfig?.name}
          </h2>
        )}
      </div>

      <div className="h-[calc(100vh-158px)] overflow-y-auto pr-4 my-3 mid-title">
        {sidebarData
          ?.filter((item) => {
            if (item.title === "Book Keeping" && !isBookKeeper) return false;
            return true;
          })
          ?.map((item, index) => {
            const iconWithProps = item?.icon
              ? React.cloneElement(item?.icon, {
                  active: isActivePath(item?.activeUrl),
                })
              : null;
            return (
              <div key={index} className="flex items-center gap-3 my-2 ps-4">
                <div
                  onClick={() => handleClick(item?.url)}
                  className={`font-medium cursor-pointer duration-200 w-full ${
                    isActivePath(item?.activeUrl)
                      ? "text-White bg-primary rounded-lg font-semibold"
                      : "text-secondary"
                  }`}
                >
                  <button className="flex items-center w-full py-2 px-6">
                    {iconWithProps}
                    <p
                      className={`ms-3 ${
                        isActivePath(item?.activeUrl)
                          ? "text-white"
                          : "text-black"
                      }`}
                    >
                      {item?.title}
                    </p>
                  </button>
                </div>
              </div>
            );
          })}
      </div>

      <div className="px-4 pb-5">
        <button
          onClick={() => setIsModalOpen(true)}
          className="btn-primary w-full flex items-center justify-center gap-3"
        >
          <Logout />
          <p>Logout</p>
        </button>
      </div>

      {/* --- Logout confirmation modal --- */}
      <ConfirmationModal
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        message="Are you sure you want to logout?"
        onConfirm={logoutHandler}
        isLoading={isLoading}
        loadingLabel="Logging out..."
      />
    </div>
  );
};

export default Sidebar;
